/* eslint-disable */
export default [
    {
        author: `Lars N.`,
        text: `"I could easily find the cheapest bus options to my destination and the app worked great!"`
    }, {
        author: `Maria P.`,
        text: `"Love it! Very quick, and even though I always use your website, today I downloaded the app and love it even more😘😘😘😘💪👍✌👋"`
    }, {
        author: `Nars K.`,
        text: `"Great app. Easy to book. Will always use Wanderu for booking a bus."`
    }, {
        author: `Alexander L.`,
        text: `"Simple, easy to use app for booking trains home from Chicago."`
    }
];
